// URL params that track the open Location Details panel. An audit belongs to
// the location it was started on, so the audit params go with the panel.
export const LOC_ID_PARAM = "locId";
export const LOC_TYPE_PARAM = "locType";
export const LOC_ASSET_ID_PARAM = "locAssetId";
export const AUDIT_MODE_PARAM = "auditMode";
export const AUDIT_ID_PARAM = "auditId";

export const AUDIT_PARAMS = [AUDIT_MODE_PARAM, AUDIT_ID_PARAM];
export const LOCATION_PARAMS = [LOC_ID_PARAM, LOC_TYPE_PARAM, LOC_ASSET_ID_PARAM, ...AUDIT_PARAMS];

// Returns a copy of `params` without the given names; defaults to every
// Location Details param.
export const clearLocationParams = (params, names = LOCATION_PARAMS) => {
  const nextParams = new URLSearchParams(params);
  names.forEach(name => nextParams.delete(name));
  return nextParams;
};
